import { StepItem } from './step-block';

export function adaptStepBlock(
  entry: Record<string, unknown>,
  _baseUrl: string,
): Record<string, unknown> {
  const rawSteps = entry['steps'];
  const steps: StepItem[] = Array.isArray(rawSteps)
    ? rawSteps.map((s: Record<string, unknown>, i: number) => ({
        number: (s['number'] as number) ?? (i + 1),
        title: (s['title'] as string) ?? '',
        description: (s['description'] as string) ?? '',
        iconSvg: (s['iconSvg'] as string) ?? undefined,
      }))
    : [];

  return { steps };
}
